import leasingi from '../assets/leasingi.jpg'
import kredytyfirmowe from '../assets/kredytyfirmowe.jpg'
import kredytyhipoteczne from '../assets/kredytyhipoteczne.jpg'
import pozyczkiunijne from '../assets/bg-pozyczkiunijne.jpg'
import {TbMedal} from 'react-icons/tb'
import {BiHappyAlt} from 'react-icons/bi'
import {RiCustomerService2Fill} from 'react-icons/ri'
import {GoTrophy} from 'react-icons/go'

export const finanseItems = [
    {
      id: 1,
      img: leasingi,
      title: "Leasingi",
      path: "/leasingi",
      text: "Finansowanie pojazdów oraz maszyn.",
    },
    {
      id: 2,
      img: kredytyfirmowe,
      title: "Kredyty firmowe",
      path: "/kredytyfirmowe",
      text: "Uzyskanie środków na prowadzenie/ rozwój Twojej firmy.",
    },
    {
      id: 3,
      img: pozyczkiunijne,
      title: "Pożyczki/ dotacje unijne",
      path: "/pozyczkiunijne",
      text: "Najtańsza forma pozyskania środków inwestycyjnych.",
    },
    {
      id: 4,
      img: kredytyhipoteczne,
      title: "Kredyty hipoteczne",
      path: "/kredytyhipoteczne",
      text: "Finansowanie zakupu nieruchomości",
    },
  ];
  
export const dlaczegoItems = [
  {
    id: 1,
    icon: <TbMedal size={60}/>,
    title: "NAJLEPSZA OFERTA",
    text: "Gwarancja najlepszej oferty rynkowej dopasowanej do potrzeb Klienta – wybieramy najlepsze rozwiązanie dostosowane do oceny Twojej zdolności. Negocjujemy warunki cenowe kredytu.",
  },
  {
    id: 2,
    icon: <RiCustomerService2Fill size={60}/>,
    title: "KOMPLEKSOWA OBSŁUGA",
    text: "Doradztwo i wsparcie  na każdym etapie procesu leasingowego , kredytowego: współpracujemy z najlepszymi profesjonalistami w swojej dziedzinie.",
  },
  {
    id: 3,
    icon: <GoTrophy size={60} />,
    title: "PROFESJONALIZM",
    text: "Ponad 15 letnie doświadczenie oraz  szeroka wiedza mi.in bankowa  właścicieli pozwala skutecznie osiągnąć wyznaczony cel zgodnie z najwyższymi standardami obsługi Klienta.",
  },
  {
    id: 4,
    icon: <BiHappyAlt size={60}/>,
    title: "NAJLEPSZA OFERTA",
    text: "Bazujemy na poleceniach, więc jesteśmy przekonani, że Twoje zadowolenie z obsługi przełoży się na kolejną rekomendację wśród Twoich znajomych i przyjaciół.",
  },
  
];

